import { z } from 'zod';

import { sessionApi } from '@ctct/infrastructure-layer';

import { zodService } from '../ZodService';

const SessionInfoSchema = z.object({
  rep: z.unknown().optional().nullable(),
});

class SessionRepo {
  public async getIsImpersonated(): Promise<boolean> {
    const response = await sessionApi.getInfo();
    const data = zodService.safeParse(SessionInfoSchema, response.data);

    return data.rep !== undefined && data.rep !== null;
  }
}

export const sessionRepo = new SessionRepo();
